module.exports = __webpack_public_path__ + "img/postback-step-7.ru.32a5645d.jpg";